<template>
  <section class="af-popover">
      <slot></slot>
  </section>
</template>

<script>
export default {
  
}
</script>

<style lang="scss">
    @import './src/assets/styles/colors.scss';

    .af-popover {
        box-shadow: 0 0 0 1px rgba(6,44,82,.1), 0 2px 16px rgba(33,43,54,.08);
        background: #fff;
        border-radius: 3px;
        padding: 18px 16px;
        border: 1px solid $color-border;
    }
</style>


// WEBPACK FOOTER //
// src/components/Popover.vue